// Estilos usados diretamente por previewData/index.js: separadores entre as
// seções (Formulario/Anexos/Observações/Diagrama) e a seção "Observações
// Finais" em si, que fica no container (acompanha o mesmo padrão do modo
// edição, ver circuito/index.js) — extraídos de styles.js (2.3-circuito) na
// Task 7 da decomposição.
const styles = (theme) => ({
	divider: {
		mt: 2,
		mb: 1,
	},
	boxContent: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		mb: 1,
		mt: 2,
	},
	boxCampos: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		p: 0.5,
	},
	observationsTypography: {
		fontSize: 14,
		color: theme.palette.text.primary,
		overflow: "hidden",
		display: "-webkit-box",
		WebkitLineClamp: 10,
		WebkitBoxOrient: "vertical",
		textOverflow: "ellipsis",
		cursor: "pointer",
		whiteSpace: "pre-wrap",
		wordBreak: "break-word",
	},
});

export default styles;
